module.exports = __webpack_public_path__ + "static/media/appstore.e7cdfff4.png";